<template>
  <div class="in-query">
    <img class="icon"  v-if="brand == 'COTTI'" src="@/assets/redirect/img_waiting.png" alt="">
    <img class="icon"  v-else-if="brand == '茶猫'" src="@/assets/redirect/teacat_img_waiting.png" alt="">
    <div class="title">稍等片刻，福利开启中</div>
  </div>
</template>

<script>
export default {
  name: 'InQuery',
  props: {
    image: {
      type: String,
      default: ''
    },
  },
  data(){
      return {
        brand: this.$config.env.VUE_APP_BRAND
      }
    },

}
</script>

<style lang="scss" scoped>
.in-query {
  .adv {
    width: 100%;
    height: auto;
  }
  .icon {
    display: block;
    width: 280px;
    height: auto;
    margin: 344px auto 32px;
  }

  .title {
    text-align: center;
    margin-top: 32px;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5E5E5E;
    line-height: 40px;
    opacity: .4;
  }
}
</style>
